import { render, staticRenderFns } from "./CompanyRiders.vue?vue&type=template&id=f891dcf4"
import script from "./CompanyRiders.vue?vue&type=script&lang=js"
export * from "./CompanyRiders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports